import StreamList from '@/components/schedule/List';
export default {
  name: 'LiveNow',
  components: {
    StreamList
  }
};